/* eslint-disable no-nested-ternary, react/destructuring-assignment */
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Input, Loader, Message, Radio } from 'semantic-ui-react';
import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';
import '../css/Profile.less';
import { VIEW_SELECTION } from '../managers/NavigationManager';

export default
@inject(
  'adminClassroomManager', 'classroomManager',
  'navigationManager', 'userManager'
)
@observer
class EditStudentProfile extends Component {
  constructor(props) {
    super(props);
    this.user = null;
    this.state = {
      rosterId: '',
      fullProfileImageUrl: '',
      textHelpEnabled: false,
      firstName: '',
      lastName: '',
      username: '',
      errorMessage: '',
      loading: false,
      saved: false,
      error: false
    };
    this.Avatar = SatCoreComponent('Avatar');
    this.UserInstitutions = SatCoreComponent('UserInstitutions');
  }

  navToRoster = async () => {
    const {
      history, classroomManager, navigationManager, userManager
    } = this.props;
    const isAdmin = userManager.isDistrictAdmin || userManager.isSchoolAdmin;
    let routerUrl = `/roster?classroomId=${classroomManager.currentClassroomId}`;
    if (isAdmin) {
      const paramsToExcludeFromStr = 'classroomId';
      const { urlParamStr } = await navigationManager.getAdminUrlParams(
        paramsToExcludeFromStr
      );
      routerUrl = urlParamStr ? `${routerUrl}&${urlParamStr}` : routerUrl;
    }
    history.push(routerUrl);
  };

  verifyChanges = async () => {
    const { classroomManager, userManager } = this.props;
    this.setState({ saved: false, error: false });
    let changesHappened = false;
    if (this.state.firstName === '' || this.state.firstName.length === 0) {
      this.setState({ saved: false, error: true, errorMessage: 'The First Name cannot be empty.' });
      return;
    }
    if (this.state.lastName === '' || this.state.lastName.length === 0) {
      this.setState({ saved: false, error: true, errorMessage: 'The Last Name cannot be empty.' });
      return;
    }
    if (this.state.username === '' || this.state.username.length === 0) {
      this.setState({ saved: false, error: true, errorMessage: 'The Username cannot be empty.' });
      return;
    }
    if (this.state.firstName &&
      this.state.firstName !== this.user.firstName) {
      changesHappened = true;
    }
    if (this.state.lastName &&
      this.state.lastName !== this.user.lastName) {
      changesHappened = true;
    }
    if (this.state.username &&
      this.state.username !== this.user.username) {
        // for students, check the username for format
        if (this.user.userRoles.toLowerCase().includes('student')) {
          let usernameResult = userManager.validateStudentUsernameFormat(this.state.username);
          if (!usernameResult.valid) {
            let errorMessage = usernameResult.errorMessage;
            this.setState({ saved: false, error: true, errorMessage });
            return;
          }
        }

      changesHappened = true;
    }
    if (changesHappened) {
      this.setState({ loading: true });
      const result = await classroomManager.editRosterStudent({
        id: this.state.rosterId,
        userId: this.state.userId,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        username: this.state.username,
        active: true
      });
      if (result) {
        this.setState({ saved: true, error: false });
        await classroomManager.fetchClassroomRoster(
          classroomManager.currentClassroomId
        );
      } else {
        this.setState({ saved: false, error: true });
      }
      this.setState({ loading: false });
    }
  };

  async componentDidMount() {
    const { classroomManager, userManager } = this.props;
    const { currentClassroomId } = classroomManager;
    const isAdmin = userManager.isDistrictAdmin || userManager.isSchoolAdmin;
    if (isAdmin && !classroomManager.getClassroom(currentClassroomId)) {
      await this.initAdminData();
    } else {
      await this.initData();
    }
  }

  initAdminData = async () => {
    const {
      adminClassroomManager,
      classroomManager, history,
      navigationManager
    } = this.props;
    const { currentClassroomId } = classroomManager;
    const classroom = await adminClassroomManager.fetchClassroom(currentClassroomId);
    if (classroom) {
      await classroomManager.setAdminClassroom(currentClassroomId, classroom);
      await this.initData();
    } else {
      const { urlParamStr } = await navigationManager.getAdminUrlParams();
      const routerUrl = `/classrooms?view=${VIEW_SELECTION.CLASSROOMS}&${urlParamStr}`;
      await history.push(routerUrl);
    }
  }

  initData = async () => {
    const {
      classroomManager, navigationManager, userManager
    } = this.props;
    const { currentClassroomId } = classroomManager;
    navigationManager.setView(VIEW_SELECTION.EDIT_STUDENT_PROFILE);
    const urlParams = new URLSearchParams(this.props.location.search);
    if (!currentClassroomId && urlParams.has('classroomId')) {
      classroomManager.setCurrentClassroomId(urlParams.get('classroomId'));
    }
    if (!this.user && urlParams.has('userId') && urlParams.has('rosterId')) {
      this.setState({ loading: true });
      const user = await userManager.fetchUser(urlParams.get('userId'));
      this.setState({ loading: false });
      if (user) {
        this.user = user;
        this.setState({
          rosterId: urlParams.get('rosterId'),
          fullProfileImageUrl: userManager.createFullAuthUrl(this.user.profileImageUrl),
          textHelpEnabled: this.user.textHelpEnabled,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          username: this.user.username,
          userId: this.user.id
        });
      }
    }
  }

  handleChangeFirstName = (e, data) => {
    this.setState({ firstName: data.value });
  };

  handleChangeLastName = (e, data) => {
    this.setState({ lastName: data.value });
  };

  handleChangeUsername = (e, data) => {
    this.setState({ username: data.value.toLowerCase() });
  };

  handleTextHelp = async () => {
    const toggle = !(this.state.textHelpEnabled);
    const { userManager, classroomManager } = this.props;
    const success = await userManager.updateStudentTextHelpOption(this.state.userId, toggle);
    if (success) {
      this.setState({ textHelpEnabled: toggle });
      await classroomManager.fetchClassroomRoster(classroomManager.currentClassroomId, 0);
    }
  }

  render() {
    const { Avatar, UserInstitutions } = this;
    const { userManager, t } = this.props;
    const {
      hideUserInstitutionsListFromProfile,
      isAlwaysReadOnlyUserInstitutionsListFromProfile,
      isSsoUser,
      isUserProfileReadOnly
    } = userManager;
    const readOnly = !isSsoUser && isUserProfileReadOnly;

    const userInstitutionsReadOnly = (
      isAlwaysReadOnlyUserInstitutionsListFromProfile || this.user?.ssoUser
    );
    return (
      <div className='profile-page'>
        <div className='profile-container'>
          <div className='profile-header'>
            <h2 tabIndex='0' className='profile-txt'>{t('headerStudentProfile')}</h2>
            <div className='avatar-controls'>
              <Avatar className='profile-avatar' fullProfileImageUrl={this.state.fullProfileImageUrl} />
            </div>
          </div>
          <div className='profile-fields'>
            <div className='profile-field-txt'>{t('firstName', 'First Name')}</div>
            <Input
              name='firstName'
              onChange={this.handleChangeFirstName}
              placeholder={t('firstName')}
              type='text'
              value={this.state.firstName} />
            <div className='profile-field-txt'>{t('lastName', 'Last Name')}</div>
            <Input
              name='lastName'
              onChange={this.handleChangeLastName}
              placeholder={t('lastName')}
              type='text'
              value={this.state.lastName} />
            <div className='profile-field-txt'>{t('username', 'Username/email')}</div>
            <Input
              disabled={readOnly}
              onChange={this.handleChangeUsername}
              placeholder={t('username')}
              type='text'
              value={this.state.username} />
            {/*
              TextHelp user opt-in toggle — previously gated TextHelp in the legacy html-publisher
              lesson player via thEnabled (not DocReader). No longer used; React player does not
              consult this preference for TextHelp visibility.
            {(userManager.publisherTextHelpActive && !userManager.showTextHelpForAll) ? (
              <>
                <div className='profile-field-txt' />
                <Radio
                  checked={this.state.textHelpEnabled}
                  disabled={false}
                  label={t('enableTextHelp')}
                  onChange={() => { this.handleTextHelp(); }}
                  toggle />
              </>
            ) : ''}
            */}
            {!hideUserInstitutionsListFromProfile && (
              <UserInstitutions
                primaryInstitutionId={this.user?.institutionId}
                readOnly={userInstitutionsReadOnly}
                userId={this.state.userId} />
            )}
          </div>
          <Button basic className='profile-change-password-btn' onClick={this.navToRoster} primary>
            {t('backToRosterButton')}
          </Button>
          <Button className='profile-save-changes-btn' onClick={this.verifyChanges} primary>
            {t('saveButton')}
          </Button>
          <Loader active={this.state.loading} />
          {this.state.saved
            ? (
              <Message positive>
                <Message.Header>{t('saveSuccessHeader')}</Message.Header>
                <p>
                  {t('saveSuccessMsg')}
                </p>
              </Message>
            ) : null}
          {(this.state.error === true) ? (this.state.errorMessage !== '' && this.state.errorMessage.length > 0)
            ? (
              <Message negative>
                <Message.Header>{t('saveErrorHeader')}</Message.Header>
                <p>
                  {this.state.errorMessage}
                </p>
              </Message>
            ) : (
              <Message negative>
                <Message.Header>{t('saveErrorHeader')}</Message.Header>
                <p>
                  {t('saveErrorMsg')}
                </p>
              </Message>
            )
            : null}
        </div>
      </div>
    );
  }
}

SatCoreRegister('EditStudentProfile', EditStudentProfile);
